var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: "移动到",
            width: "480px",
            "append-to-body": true,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "tree-box mt10" },
            [
              _c(
                "el-scrollbar",
                { staticStyle: { height: "100%" } },
                [
                  _c("el-tree", {
                    ref: "tree",
                    attrs: {
                      data: _vm.treeData,
                      props: _vm.defaultProps,
                      "highlight-current": true,
                      "default-expanded-keys": [1],
                      "expand-on-click-node": false,
                      "node-key": "id",
                    },
                    on: { "node-click": _vm.handleClick },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var node = ref.node
                          var data = ref.data
                          return _c(
                            "div",
                            { staticClass: "custom-tree-node" },
                            [
                              _c("span", { staticClass: "flex-box" }, [
                                data.icon
                                  ? _c("i", {
                                      staticClass: "el-icon-s-home",
                                      attrs: { "icon-class": data.icon },
                                    })
                                  : _c("i", {
                                      staticClass:
                                        "icon iconfont iconwenjianjia color-file",
                                    }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(data.name) +
                                    "\n            "
                                ),
                              ]),
                            ]
                          )
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer text-right",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.saveLoading,
                  },
                  on: { click: _vm.handleSave },
                },
                [_vm._v(_vm._s(_vm.$t("public.ok")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }